module.exports = __webpack_public_path__ + "static/media/gallery04.793d5250.jpg";